export default function formatMillis(ms: number): string {
  return new Date(ms).toISOString().substr(11, 8);
}
